export default __webpack_public_path__ + "static/media/Front-Apartment-Mr-El-Sayid-6.609223d4.jpg";